"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/reTitle/index"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RealTitle: _index.default
  },
  data: function data() {
    return {
      backPath: '/teacherIndex',
      awardsActNum: 0,
      itemsActNum: 0,
      tabsActNum: 0,
      titleInfo: {
        sec: "历年作品展示"
      },
      currentPage4: 4,
      typeList1: [{
        name: '"最美班主任"组',
        id: "11"
      }, {
        name: "名班主任工作室建设组",
        id: "21"
      }, {
        name: "班主任业务能力组",
        id: "31"
      }],
      typeList2: [{
        name: 2021,
        id: "1"
      }, {
        name: "2020",
        id: "2"
      }, {
        name: "2019",
        id: "3"
      }, {
        name: "2019之前",
        id: "4"
      }],
      typeList3: [{
        name: "图片",
        id: "121"
      }, {
        name: "文档",
        id: "131"
      }, {
        name: "视频",
        id: "141"
      }],
      cardItem: [{
        // eslint-disable-next-line no-undef
        imgUrl: "",
        // eslint-disable-next-line no-undef
        cardHd: "",
        cardName: "路人A",
        cardTitle: "班级活动的实践方案",
        fileType: "mp4",
        cardDate: "2018-11-02 13:15"
      }],
      hisWorksTypeInfo: {
        title: ["2022年广东省中等职业学校班主任业务能力大赛", "2022年大赛视频"],
        awards: ["一等奖", "二等奖"]
      },
      renderInfo: {
        title: ["参赛作品", "所属教育局", "所属学校", "所属大类"],
        renderList: [["暂无数据", "暂无数据", "暂无数据", "暂无数据"]]
      }
    };
  },
  methods: {
    goWorksOfYear: function goWorksOfYear() {
      this.$router.push("/hisWorks");
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
    },
    getCardList: function getCardList(e) {
      console.log(e);
      var arr = [];
      var v = JSON.parse(JSON.stringify(e));
      arr.push(v);
      console.log(arr);
    },
    items: function items(e) {
      this.itemsActNum = e;
    },
    awards: function awards(e) {
      this.awardsActNum = e;
    }
  }
};